import React from 'react'
import im1 from '../images/100.jpg'

export default function Banner() {
    return (
      
         
             <div className='container'>
                <div className='row'>
                    <div className='col-6'>
                        <div className='header-con'>
                            <div className="header-sec">
                            <ul className='header-ul'>
                                <li ><i class="fab fa-facebook-square"></i></li>
                                <li ><i class="fab fa-twitter-square"></i></li>
                                <li ><i class="fab fa-instagram"></i></li>
                                <li ><i class="fab fa-pinterest"></i></li>
                            </ul>
                            
                            <h1>I am Naimul  islam</h1>
                            <p>Hellow I am naimul Islam,proffesional web devoloper with long time experience
                                in the field
                            </p>
                            <div className='header-button'>
                                <a href='' className='btn btn-outline'>My protfolio</a>&nbsp; &nbsp; &nbsp;
                                <a href='' className='btn btn-smart'><i class="fas fa-play"></i></a>&nbsp; &nbsp; &nbsp;
                            </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-6'>
                     <div className='ban-img'>
                         <img src={im1} alt="" />
                     </div>

                    </div>
                    
                    </div>  
             </div>

          
      
    )
}
